

import { createContext, useContext, useEffect, useState } from "react";

import { CommonContext } from "../../App";

import toast from "react-hot-toast";
import axios from "axios";
import api from "../../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { setUserData } = useContext(CommonContext);
  axios.defaults.withCredentials = true;
const API_BASE=process.env.REACT_APP_BASE_URL;
  // Verify user on page load or refresh
  
  useEffect(() => {
    
  //   window.addEventListener("message", (event) => {
  //     console.log("ram ram ")
  //   if (event.data.type === "RESTORE_SESSION") {
  //     // Force verify again after token restore
  //     verifyUser();
  //   }
  // });
    
    const verifyUser = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_BASE}auth/verify`, { withCredentials: true });
        if (res.data.success) {
          setUser(res.data.user);
          setUserData({ user: res.data.user, token: '' });
        } else {
          setUser(null);
          setUserData({ user: null, token: '' });
        }
      } catch (err) {
        console.error("Verify user error:", err);
        setUser(null);
        setUserData({ user: null, token: '' });
      } finally {
        setLoading(false);
      }
    };

    verifyUser();
  }, [setUserData]);

  const login = async (userData) => {
    setUser(userData);
    setUserData({ user: userData, token: '' });
  };

  const logout = async () => {
    try {
     const res= await api.post(`auth/logout`, {}, { withCredentials: true });
        if (res.data.success) {
        setUserData({ user: "", token: "" });
        localStorage.removeItem("selectedBranchId");
        toast.success("Logout successfully");
      }
    } catch (err) {
      console.error("Logout error:", err);
    }
    // Clear both states
    setUser(null);
    setUserData({ user: null, token: '' });
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);